import { Box, TextField } from '@mui/material';
import { Typography } from '@peritasai/ui-components';

export interface NoteFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  helperText: string;
  testId: string;
}

/** Labelled multiline note input with a character-count helper, shared across the details dialogs. */
export const NoteField = ({ label, value, onChange, helperText, testId }: NoteFieldProps) => (
  <Box>
    <Typography
      variant="body2"
      display="block"
      sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '17px', mb: 0.5 }}
    >
      {label}
    </Typography>
    <TextField
      multiline
      rows={6}
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      slotProps={{
        htmlInput: {
          'aria-label': label,
          'data-testid': testId,
        },
      }}
      helperText={helperText}
    />
  </Box>
);
